import React from 'react';
import styled from '@emotion/styled';
import { text } from 'style/mixin';
import fonts from 'style/fonts';
import { mq } from 'style/variables';
import { Global, css } from '@emotion/core';

type DescriptionListProps = {
  labels: string[];
  contents: string[];
};

const DescriptionListWrapper = styled.div`
  width: 100%;
  margin-top: 9px;
`;

const DescriptionListItemWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  padding: 20px 0px 19px;

  &:nth-of-type(1) {
    border-top: 1px solid #d9d9d9;
  }

  ${mq.onlysp} {
    padding: 22px 0 25px;
  }
`;

const DescriptionListItem = styled.dl`
  display: flex;
  gap: 14px;
  justify-content: space-between;

  ${mq.onlysp} {
    flex-direction: column;
  }
`;

const DescriptionListTitle = styled.dt`
  flex-shrink: 0;
  ${text(20, 1, true)}
  font-family: ${fonts.jaGothic};
  line-height: 1.8;
  color: #333;
  font-weight: 600;
  width: 104px;
  min-width: 104px;

  ${mq.onlysp} {
    ${text(17, 1, true)}
    margin-top: 2px;
  }
`;

const DescriptionListText = styled.dd`
  flex: 1;
  font-family: ${fonts.jaGothic};
  ${text(18, 1.3, true)}
  color: #333;
  padding: 9px 0;

  ${mq.onlysp} {
    ${text(14, 1.4, true)}
  }

  strong {
    display: inline-block;
    font-weight: 600 !important;
    ${text(18, 1, true)}
    padding-left: 10px;

    ${mq.onlysp} {
      ${text(15, 1, true)}
    }
  }

  .text-small {
    ${text(14, 1.48, true)}
    margin-left: 5px;

    ${mq.onlysp} {
      ${text(13, 1.4, true)}
    }

    span {
      ${text(14, 1.4, true)}

      ${mq.onlysp} {
        ${text(13, 1.4, true)}
      }
    }
  }
`;

export const DescriptionList = ({ labels, contents }: DescriptionListProps) => {
  return (
    <>
      <Global
        styles={css`
          strong {
            font-size: 18px;
            line-height: 1.8;
            margin-bottom: calc((1.8 - 1) * 18px / 2 * -1);
            padding-left: 10px;
          }

          .text-small {
            font-size: 14px;
            line-height: 1.8;
            margin-bottom: calc((1.8 - 1) * 14px / 2 * -1);
          }

          figure.table {
            margin: 0;
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
            font-size: 16px;
            line-height: 1.8;
            margin-bottom: calc((1.8 - 1) * 16px / 2 * -1);
          }

          figure.table colgroup {
            display: none;
          }

          figure.table tr {
            display: flex;
            gap: 25px;
            width: 100%;
          }

          figure.table tr td {
            flex: 1;
            vertical-align: top;
            padding: 0;
            border: none;
          }

          figure.table ul {
            margin: 0 5px;
          }

          figure.table li {
            .text-small {
              display: inline-block;
              margin-left: 22px;
            }
          }

          figure.table li::before {
            content: '・';
            margin-right: 10px;
          }

          figure.table p {
            // padding-top: 6px;
          }

          figure.table p:not(:nth-of-type(1)) {
            padding-top: 15px;
          }

          @media (max-width: 767px) {
            figure.table {
              margin-top: 9px;
            }

            figure.table tr {
              flex-direction: column;
              gap: 20px;
            }

            figure.table li {
              font-size: 14px;
              line-height: 1.43;
              margin-top: 2px;
            }

            figure.table p {
              font-size: 14px;
              line-height: 1.58;
              margin-top: 3px;
              margin-left: 6px;
            }

            figure.table p:not(:nth-of-type(1)) {
              margin-top: 20px;
            }
          }
        `}
      />
      <DescriptionListWrapper>
        {labels.map((label, index) => (
          <React.Fragment key={index}>
            <DescriptionListItemWrapper>
              <DescriptionListItem>
                <DescriptionListTitle>{label}</DescriptionListTitle>
                <DescriptionListText dangerouslySetInnerHTML={{ __html: contents[index] }} />
              </DescriptionListItem>
            </DescriptionListItemWrapper>
          </React.Fragment>
        ))}
      </DescriptionListWrapper>
    </>
  );
};
